/// Termos de Uso e Política de Privacidade da plataforma (ADR 0067). A versão é a data da
/// redação: mudar o texto é mudar a versão aqui, e a API passa a pedir o aceite de novo antes do
/// próximo pedido de horário. O texto vive na web; a versão vive aqui para os dois lados lerem a
/// mesma.
export const LEGAL_DOCUMENTS = Object.freeze({
  TERMS: Object.freeze({ version: '2026-10-15', label: 'Termos de Uso' }),
  PRIVACY: Object.freeze({ version: '2026-10-15', label: 'Política de Privacidade' }),
});

export type LegalDocumentKey = keyof typeof LEGAL_DOCUMENTS;

export const LEGAL_DOCUMENT_KEYS = Object.freeze(
  Object.keys(LEGAL_DOCUMENTS) as LegalDocumentKey[],
);

/// Tamanho do nome de tratamento ("Como você gostaria de ser chamado(a)?").
export const PREFERRED_NAME_MAX_LENGTH = 40;
